import { gsap } from 'gsap';
import * as PIXI from 'pixi.js';
import { PixiPlugin } from 'gsap/PixiPlugin';
import { TextPlugin } from 'gsap/TextPlugin';

import { Spine } from '../../core/classes/spine';
import { isMobile } from '../../core/helpers/isMobile';

import { WinningLinesCoordinate10 } from '../../gameConstants';
import { gameStore } from '../../store/gameStore';

class GameResourcesService {
  allLinesSpine = [];

  allWinLinesBone = [];

  winCoinSpine = null;

  expandWildSpine = null;

  winLineTimeOutId = null;

  winAmountTexture = null;

  setupPixiPlugins() {
    gsap.registerPlugin(PixiPlugin);
    gsap.registerPlugin(TextPlugin);
    PixiPlugin.registerPIXI(PIXI);
  }

  setWinAmountTexture(texture) {
    this.winAmountTexture = texture;
  }

  setWinCoinSpine(spine) {
    this.winCoinSpine = spine;
  }

  setExpandWildSpine(spine) {
    this.expandWildSpine = spine;
  }

  resetExpandWildSpine() {
    this.expandWildSpine.forEach((wild) => {
      gameStore.setIsExpandWildOpen(false);
      wild.isOpen = false;
      wild.stop();
    });
  }

  setupAllLine(parentContainer) {
    [...WinningLinesCoordinate10, ...WinningLinesCoordinate10].forEach((_, i) => {
      const winLine = new Spine({ key: 'winLine' });
      winLine.visible = false;
      const reverseStartPossession = isMobile() ? 510 : 1006;
      winLine.x += i + 1 > 10 ? reverseStartPossession : 0;
      this.allLinesSpine.push(winLine);
      parentContainer.addChild(winLine);
    });
    this.allWinLinesBone = this.allLinesSpine.map((el) =>
      el.skeleton.bones
        .filter((bone) => {
          return bone.data.name.includes('bone');
        })
        .sort((a, b) => (a.x > b.x ? 1 : b.x > a.x ? -1 : 0))
    );
  }

  resetAllLineSpine() {
    this.allLinesSpine.forEach((line) => {
      line.stop();
      line.visible = false;
    });
    clearTimeout(this.winLineTimeOutId);
  }
}

export const gameResourcesService = new GameResourcesService();
